import React from "react"
import { Row, Col, Space, Button, Tag, Typography } from "antd"
import { RollbackOutlined } from "@ant-design/icons"

const { Title } = Typography

interface NoteHeaderProps {
  documentNumber?: string | null
  isMobile?: boolean
  onBack: () => void
}

export const NoteHeader: React.FC<NoteHeaderProps> = ({
  documentNumber,
  isMobile,
  onBack
}) => {
  return (
    <Row 
      gutter={[16, 16]} 
      align="middle" 
      style={{ marginBottom: isMobile ? 12 : 20 }} 
      justify="space-between"
    >
      <Col xs={24} sm="auto">
        <Space align="center" wrap>
          <Button icon={<RollbackOutlined />} onClick={onBack} />
          <Title level={isMobile ? 4 : 3} style={{ margin: 0 }}>
            Crear Nota para Factura{" "}
            <Tag 
              color="blue" 
              style={{ 
                fontSize: isMobile ? 14 : 16, 
                padding: '2px 8px', 
                marginLeft: 4 
              }}
            >
              {documentNumber}
            </Tag>
          </Title>
        </Space>
      </Col>
    </Row>
  )
}
